import gql from 'graphql-tag';

export default gql`
query ($id: String!) {
  getAdvertiser (id: $id) {
    __typename
    id
    name
    costModifier
    postClickLookback
    postViewLookback
    reports {      
      id
        version
        name
        status
        pages{
          index
          name
          displayName
          default
          visible
        }
        reportTypeId
        menuLabel
        menuOrder
        powerBiDataset
        powerBiEmbedUrl
        powerBiReport
        accessToken    
    }
    accessControlList{
      id
      userName
    }
    acl
    brands
  }
  listUsers {
    items {
      __typename
      id
      emailAddress
      active
      status
    }
  }
  listReportTypes {
    items {
      __typename
      id
      name
    }
  }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/Advertisers/GetQuery.js